<template>
  <div>
    <router-view />
    <NotificationCenter class="tw-fixed tw-bottom-2 tw-right-2" />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    NotificationCenter: () => import("@/ui/components/chat/NotificationCenter.vue"),
  },
  data() {
    return {
      leftDrawerOpen: false,
      env: "dev",
    };
  },
  mounted() {
    console.log("channel", this.$store.getters["customerChat/channel"]);
  },
};
</script>

<style lang="scss">
.loading {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.q-badge--floating {
  position: absolute;
  top: -5px;
  right: -10px;
  cursor: inherit;
}
// .q-dialog {
//     z-index: 999999 !important;
// }
</style>

<style>
body {
  background-color: #f2f3f4;
  overscroll-behavior-y: none;
}
.text-title {
  font-size: 28px;
  line-height: 1.4;
  color: #222;
  font-weight: 400;
}
.set-txt-click {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
</style>
